import NotFoundComponent from "PFComponents/not_found/not_found";
import usePageWrapper from "PFCore/helpers/use_page_wrapper";
import CollaboratorsConfigsPage from "PFModules/admin/collaborators_configs/list/collaborators_configs_page";
import React from "react";
import { useTranslation } from "react-i18next";

import { useCollaboratorsConfigs } from "./use_collaborators_configs";

const initPage = { collaboratorConfigs: null, loaded: false };

const CollaboratorsConfigsController = () => {
  const { t } = useTranslation("collaboratorsConfigs", { keyPrefix: "list" });
  const { loaded, collaboratorsConfigs, errors, fetchCollaboratorsConfigs } =
    useCollaboratorsConfigs(initPage);
  const WrappedCollaboratorConfigPage = usePageWrapper(CollaboratorsConfigsPage);

  return (
    <WrappedCollaboratorConfigPage
      loading={!loaded}
      errors={errors}
      errorComponent={
        <NotFoundComponent
          message={t("pageCouldNotBeLoaded")}
          buttonMessage={t("translation:comeBackLater")}
          buttonUrl="/admin/collaborators_configs"
        />
      }
      collaboratorsConfigs={collaboratorsConfigs}
      fetchCollaboratorsConfigs={fetchCollaboratorsConfigs}
    />
  );
};

export default CollaboratorsConfigsController;
